import { useConfigStore } from '~/store/useConfigStore'
import type { RealTimeStock } from '~/types/models/real-time-stock'

export const useTickerInfo = (autoload: boolean = true) => {
  const { warn } = console
  const config = useConfigStore()

  const ticker = computed<string | undefined | null>(() => config.$state?.kaleidoscopeTicker)

  const tickerData = ref<RealTimeStock.Model>()

  const { getRealTimeTicker } = useKaleidoscopeApi()

  const load = async () => {
    if (!config.$state.kaleidoscopeConfigured) {
      warn('Kaleidoscope is not configured for the tenant')

      return
    }

    try {
      const response = await getRealTimeTicker()

      tickerData.value = response.data
    }
    catch (ex: unknown) {
      warn('Failed to load real-time ticker', ex)
      useHandleException(ex)
    }
  }

  onMounted(() => {
    if (autoload) {
      load().catch(useHandleException)
    }
  })

  return { ticker, tickerData, load }
}
